export default __webpack_public_path__ + "static/blue-linear-bg-e50137affba0af254559e85d8ffb8493.png";